module.exports = __webpack_public_path__ + "static/ss.1e508d84.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/projects/tb/ss.png
// module id = 1206
// module chunks = 277036769636407